// extracted by mini-css-extract-plugin
module.exports = {"container":"_2X87HgjqYTfFGUt-Bki8Qh"};